import { SyncServiceActionTypes, SET_AVAILABLE_SERVICES } from './types';
import { SyncService } from '../../../Types';

export const setAvailableServices = (availableServices: SyncService[]): SyncServiceActionTypes => ({
  type: SET_AVAILABLE_SERVICES,
  availableServices
});
